import $ from 'jquery';
import 'slick-carousel';

const latestTweets = {
	init() {
		this.tweetEls = document.querySelectorAll('.em-tweets');
		if (this.tweetEls) {
			$(this.tweetEls).slick(
				{
					arrows: false,
					dots: true,
					rows: 0, // Remove extra <div> from slick markup.
				},
			);
		}
	},
};

latestTweets.init();
